/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import Header from "../Header";
import SideBar from "../Sidebar";
import useWindowWidth from "../../utils/windowWidth";
import BookShelf from "../../pages/BookShelf/BookShelf";

import "bootstrap/dist/css/bootstrap.min.css";
import "./BookListPage.css";
import back from "../../assets/back.svg";
import verticalDots from "../../assets/vertical-dots.svg";
import BookDownloadModal from "../bookDownloadModal";
import BookReviewModal from "../bookReviewModal";
import { ADD_BOOK_FROMAT, ADD_BOOK_REVIEW, GET_ALL_COMMENTS, SAVE_BOOK_IN_SELF, GET_TELANGANA_BOOKS, REACT_APP_BASE_URL } from "../../utils/constants";
import {
  makeAuthenticatedGet,
  makeAuthenticatedPost,
} from "../../utils/fetchUtils";
import { REACT_APP_SHRAVAN_BASE_URL, GET_BOOKS } from "../../utils/constants";

function BookListPage() {
  const { language, mainCategory, category } = useParams();
  const navigate = useNavigate();
  const mainRef = useRef(null);
  const location = useLocation();

  const [bookDetails, setBookDetails] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedMainCategory, setSelectedMainCategory] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("Hindi");
  const [selectedFormat, setSelectedFormat] = useState("");
  const [books, setBooks] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [shelf, setShelf] = useState(false);
  const [showInfo, SetShowInfo] = useState(false);
  const [downloadShow, setDownloadShow] = useState(false);
  const [reviewShow, setReviewShow] = useState(false);
  const [message, setMessage] = useState("");
  const [bookContext, setBookContext] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadClose = () => setDownloadShow(false);
  const handleDownloadShow = () => setDownloadShow(true);

  const handleReviewClose = () => setReviewShow(false);
  const handleReviewShow = () => setReviewShow(true);

  const handleSetBookContext = (bookName) => setBookContext(bookName);

  const booksPerPage = 10;

  const handleMoreDetailsBtn = () => {
    SetShowInfo((prev) => !prev);
  };

  const userPhoneNumber = localStorage.getItem("userPhoneNumber");

  // Fetch books on component mount
  useEffect(() => {
    if (category) {
      setSelectedCategory(category);
    }
    if (language) {
      setSelectedLanguage(language);
    }
    if (mainCategory) {
      setSelectedMainCategory(mainCategory);
    }

    const fetchBooks = async () => {
      setCurrentPage(1);
      try {
        if (category) {
          setLoading(true);
          setError(null);
          const encodedCategory = encodeURIComponent(category);
          const response = await axios.get(
            `${REACT_APP_SHRAVAN_BASE_URL}/booksByCategoryAndLang?category=${encodedCategory}&language=${language}&limit=${booksPerPage}`
          );
          const data = await response.data;
          setBooks(data);
          setShowLoadMore(true);
        } else {
          setBooks(null); // Clear books if no category is selected
          setShowLoadMore(false);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchNcludeBooks = async (query = "") => {
      try {
        const url = query
          ? `${GET_BOOKS}?page=${1}&limit=${booksPerPage}`
          : GET_BOOKS + `?page=${1}&limit=${booksPerPage}`;
        const response = await makeAuthenticatedGet(url);
        const temp = response;
        // console.log(temp);
        // setTotalBooks(temp.totalBooks);
        setBooks(temp.books);
        // setTotalPages(Math.floor((temp.totalBooks - 1) / limit) + 1);
        setShowLoadMore(true);
      } catch (error) {
        if (error.response && error.response.data) {
          setMessage(error.response.data.message);
        }
        setError(error.message);
        console.error("Error fetching books: ", error);
      }
    };
    
    const fetchTelanganaBooks = async (query = "") => {
      try {
        const encodedCategory = encodeURIComponent(category);
        const url = `${GET_TELANGANA_BOOKS}?page=${1}&limit=${booksPerPage}&category=${encodedCategory}&language=${language}`;
        const response = await makeAuthenticatedGet(url);
        const temp = response;
        // console.log(temp);
        // setTotalBooks(temp.totalBooks);
        setBooks(temp.books);
        // setTotalPages(Math.floor((temp.totalBooks - 1) / limit) + 1);
        setShowLoadMore(true);
      } catch (error) {
        if (error.response && error.response.data) {
          setMessage(error.response.data.message);
        }
        setError(error.message);
        console.error("Error fetching books: ", error);
      }
    };

    if (category === "Nclude Books") {
      fetchNcludeBooks();
    }else if (category === "Telangana Books") {
      fetchTelanganaBooks();
    } else {
      fetchBooks();
    }
  }, []);


  const handleAudioBookClick = (audiobook) => {
    localStorage.setItem("currentAudiobook", JSON.stringify(audiobook));
  };

  const handleLoadMore = async () => {
    if (selectedCategory) {
      setLoading(true);
      setError(null);

      const currentPageCount = currentPage;
      try {
        if (category === "Nclude Books") {
          const url =
            GET_BOOKS + `?page=${currentPageCount + 1}&limit=${booksPerPage}`;
          const response = await makeAuthenticatedGet(url);
          const temp = response;
          // console.log(temp);
          setBooks([...books, ...temp.books]);
          setCurrentPage(currentPageCount + 1);
        } else if (category === "Telangana Books") {
          const encodedCategory = encodeURIComponent(category);
          const url = `${GET_TELANGANA_BOOKS}?page=${currentPageCount + 1}&limit=${booksPerPage}&category=${encodedCategory}&language=${language}`;
          const response = await makeAuthenticatedGet(url);
          const temp = response;
          if(temp.books){
            setBooks([...books, ...temp.books]);
          }

          if((books.length + temp.books.length) >= temp.totalBooks){
             setShowLoadMore(false);
          }

          setCurrentPage(currentPageCount + 1);
        } else {
          const response = await axios.get(
            `${REACT_APP_SHRAVAN_BASE_URL}/booksByCategoryAndLang?category=${selectedCategory}&language=${selectedLanguage}&page=${currentPageCount + 1
            }&limit=${booksPerPage}`
          );
          const data = await response.data;
          setCurrentPage(currentPageCount + 1);
          if (data.length) {
            setBooks([...books, ...data]);
          } else {
            setShowLoadMore(false);
          }
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    } else {
      console.log("empty books");
      setBooks(null); // Clear books if no category is selected
      setShowLoadMore(false);
    }
  };

  const handleBookSave = async (selectedFormat, formatUrl) => {
    try {
      const body = {
        bookId: bookDetails._id,
        formatType: selectedFormat,
        formatLink: formatUrl,
      };
      const response = await makeAuthenticatedPost(
        SAVE_BOOK_IN_SELF,
        JSON.stringify(body)
      );
      setMessage(response.message);
      // console.log(response);
    } catch (error) {
      if (error.response && error.response.data) {
        // console.log(error.response.data.message)
        setMessage(error.response.data.message);
      }
      // console.log(error);
    }
  };

  const handleNcludeDownloadBtn = async () => {
    setMessage("Please Wait while we fetch this format of the book...");    
    setIsDownloading(true);
    const format = bookContext.formats.find(
      (f) => f.formatType.toLowerCase() === selectedFormat.toLowerCase()
    );

    if (format && format.url) {
      //make post to donwload a zip
      const payload = {
        s3Url : format.url
      }
      const response = await axios.post(`${REACT_APP_BASE_URL}/user/getMp3Zip`, payload, { responseType: 'blob' });
      
      const blob = new Blob([response.data], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `${bookContext.title}.zip`;
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);

      handleDownloadClose();
      handleBookSave(selectedFormat, format.url);
    } else if (selectedFormat) {
      const body = {
        bookId: bookContext._id,
        formatType: selectedFormat,
      };

      try {
        const response = await makeAuthenticatedPost(
          ADD_BOOK_FROMAT,
          JSON.stringify(body)
        );
        if (response.success) {
          setBookDetails((prevDetails) => ({
            ...prevDetails,
            formats: [...prevDetails.formats, response.newFormat],
          }));
          // console.log(response);
          window.open(response.newFormat.url, "_blank");
          handleBookSave(response.newFormat.formatType, response.newFormat.url);
        } else {
          setMessage(response.message);
        }
      } catch (error) {
        if (error.response && error.response.data) {
          // console.log(error.response.data.message)
          setMessage(error.response.data.message);
        }
        // console.log(error);
      }
    } else {
      alert("Please select a format.");
    }
    setIsDownloading(false);
  };

  const handleDownloadBtn = async (book) => {
    try {
      setError(null);
      const response = await axios.get(
        `${REACT_APP_SHRAVAN_BASE_URL}/downloadd/${book.bookName}/${userPhoneNumber}`, {
        responseType: 'blob'
      }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');
      link.href = url;
      link.download = `${book.bookName}.zip`;
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      if (error.response && error.response.data) {
        // console.log(error.response.data.message)
        setMessage(error.response.data.message);
      }
      // console.log(error);
    }
  };

  const submitReview = async (bookId, rating, comment) => {
    handleReviewClose();
    const reviewData = {
      bookId,
      rating,
      comment,
    };

    try {
      const response = await makeAuthenticatedPost(
        ADD_BOOK_REVIEW,
        JSON.stringify(reviewData)
      );
      if (response.success) {
        console.log(response);
      } else {
        console.log("error : ", response);
      }
    } catch (error) {
      console.error("Failed to submit review", error);
      // Handle error (e.g., show error message)
    }
  };

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="">
      {!isMobile && <Header activePage="lib" curr={0} setShelf={setShelf} />}
      <div className="page-container">
        <SideBar activePage="Library" />
        {isMobile && <header className="mobile-header">
      <div className="accessibility-header" id="accessibility-menu" tabIndex={-1}>
        <div tabIndex={0} onClick={()=> setShelf(false)} className={shelf?"":"active-accessibility-header"}>{'Browse All Books'}</div>
        <div tabIndex={0} onClick={()=> setShelf(true)} className={shelf?"active-accessibility-header":""}>Book Shelf</div>
      </div>  
    </header>}
        <div className="doc-container" role="main" tabIndex={-1} style={{ paddingTop: isMobile?"2rem":""}}>
          {shelf && <BookShelf />}

          {!shelf && (
            <div>
              <div className="">
                <section className="header-wrap d-flex justify-content-start align-items-center">
                  <div>
                    <div
                      style={{
                        color: "#5030E5",
                        cursor: "pointer",
                        fontSize: isMobile ? "2.5rem" : "1rem",
                        gap: "0.2rem",
                        marginBottom:isMobile?"2rem":"1rem"
                      }}
                      role="button"
                      className="d-flex single-article back-button"
                      onClick={() => navigate(-1)}
                    >
                      <img src={back} alt="" style={{ width: isMobile?"3rem":"2rem" }}/>
                      Back
                    </div>
                    <h1 className="logo my-auto mt-5" ref={mainRef} tabIndex={-1}>
                      <span className="">Nclude Audiobooks Library</span>
                    </h1>

                    <header className="">
                      <div
                        style={{
                          width: "100%",
                          height: "fit-content",
                          marginTop: "5rem",
                        }}
                        className="d-flex justify-between items-center"
                      >
                        <div className="d-flex justify-center items-center category-header">
                          <h2>
                            Audiobooks listed under {selectedCategory} in{" "}
                            {selectedLanguage} language
                          </h2>
                        </div>
                        {/* <div
                        className="newsDropdownContainer "
                        style={{ width: "25%" }}
                      >
                        <div className="input-div-search">
                          <h2 id="output-format" className="form-label sr-only">
                            Select Language
                          </h2>
                          <select
                            className="form-control input-6"
                            id="language"
                            name="language"
                            aria-label="Select Language"
                            value={selectedLanguage}
                            onChange={(event) => {
                              const lang = event.target.value;
                              localStorage.setItem("currentLanguage", lang);
                              setSelectedLanguage(lang);
                            }}
                            aria-labelledby="language"
                            required
                          >
                            <option key="hindi" value="Hindi">
                              Hindi
                            </option>
                            <option key="english" value="English">
                              English
                            </option>
                          </select>
                        </div>
                      </div> */}
                      </div>
                    </header>
                  </div>
                </section>
                {books != null && books.length > 0 ? (
                  <section className="mt-5 component-container">
                    <div
                      className="audio-book-feed justify-content-center align-items-center card-container"
                      id="secondary-content"
                      style={{
                        padding: "20px",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      {/* {selectedCategory && (
                        <header>
                          <h3 className="title text-start">
                            Audiobooks listed under {selectedCategory} in{" "}
                            {selectedLanguage} language
                          </h3>
                        </header>
                      )} */}
                      <div className="category-list w-100 audiobooks-list mt-3">
                        {books.map((audiobook, index) => (
                          <div
                            key={audiobook._id}
                            className="border-2 border-white flex md:w-[80%] px-6 lg:px-6 p-12 rounded audiobook-item booklist-book"
                          >
                            {
                              !["Nclude Books", "Telangana Books"].includes(category) ? 
                              (
                                <Link
                                  to={`/play/${selectedMainCategory}/${selectedCategory}/${audiobook.bookName}`}
                                  onClick={() => handleAudioBookClick(audiobook)}
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                >
                                  <div className="result-data d-flex flex-column justify-content-start align-items-baseline flex-wrap">
                                    <div className="mb-3">
                                      <p className="mb-0">
                                        {index + 1}.{" "}
                                        {audiobook.bookName
                                          ? audiobook.bookName
                                          : audiobook.title}
                                      </p>
                                    </div>
                                    {audiobook.author && (
                                      <div
                                        style={{
                      
                                          color: "rgba(120, 116, 134, 1)",
                                        }}
                                        className="mt-3"
                                      >
                                        <span className="book-author">
                                          Author: {audiobook.author}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </Link>
                              )
                              :
                              (
                                <div className="result-data d-flex flex-column justify-content-start align-items-baseline flex-wrap">
                                  <div className="mb-3">
                                    <p className="mb-0">
                                      {index + 1}.{" "}
                                      {audiobook.bookName
                                        ? audiobook.bookName
                                        : audiobook.title}
                                    </p>
                                  </div>
                                  {audiobook.author && (
                                    <div
                                      style={{
                    
                                        color: "rgba(120, 116, 134, 1)",
                                      }}
                                      className="mt-3"
                                    >
                                      <span className="book-author">
                                        Author: {audiobook.author}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              )
                            }

                            <div className="d-flex justify-end dropdownn">
                              <button
                                className="mt-1 options-btn dropdown-toggle"
                                data-bs-toggle="dropdown"
                                onClick={handleMoreDetailsBtn}
                              >
                                {
                                  // showInfo ? 'Less Details' : "More Details and Download"
                                  <img src={verticalDots} alt="options" />
                                }
                              </button>
                              <ul className="dropdown-menu">
                                {/* <button type="button" className="btn-close dropdown-close" aria-label="Close"></button> */}
                                {/* <li>
                                  <a className="dropdown-item" href="/">
                                    Read it Online
                                  </a>
                                </li> */}
                                <li>
                                  <a
                                    role="button"
                                    className="dropdown-item"
                                    onClick={() => handleReviewShow()}
                                  >
                                    Review
                                  </a>
                                  <BookReviewModal
                                    show={reviewShow}
                                    handleClose={handleReviewClose}
                                    book={audiobook}
                                    submitReview={submitReview}
                                  />
                                </li>
                                {/* <BookReviewModal
                                  show={reviewShow}
                                  handleClose={handleReviewClose}
                                  book={book}
                                  submitReview={submitReview}
                                /> */}
                                <li>
                                  <a
                                    role="button"
                                    className="dropdown-item"
                                    onClick={() => { 
                                      handleSetBookContext(audiobook); 
                                      if(category === "Nclude Books" || category == "Telangana Books"){
                                        handleDownloadShow(); 
                                      }else {
                                        handleDownloadBtn(audiobook)
                                      }                                      
                                    }}
                                  >
                                    Download
                                  </a>
                                </li>
                                <BookDownloadModal
                                  show={downloadShow}
                                  handleClose={handleDownloadClose}
                                  selectedFormat={selectedFormat}
                                  setSelectedFormat={setSelectedFormat}
                                  handleDownloadBtn={["Nclude Books", "Telangana Books"].includes(category) ? handleNcludeDownloadBtn : handleDownloadBtn}
                                  book={bookContext}
                                  setBookDetails={setBookDetails}
                                  isDownloading={isDownloading}
                                  category={category}
                                />
                              </ul>
                            </div>
                          </div>
                        ))}
                      </div>
                      {showLoadMore && (
                        <button
                          className="load-more-button doc-submit"
                          onClick={handleLoadMore}
                        >
                          Load More
                        </button>
                      )}
                    </div>
                    {/* <BookDownloadModal
                    show={downloadShow}
                    handleClose={handleDownloadClose}
                    selectedFormat={selectedFormat}
                    setSelectedFormat={setSelectedFormat}
                    handleDownloadBtn={category === "Nclude Books" ? handleNcludeDownloadBtn : handleDownloadBtn}
                    book={bookContext}
                    setBookDetails={setBookDetails}
                    /> */}
                  </section>
                ) : (
                  <div className="empty-container mt-5">
                    {books && books.length == 0 ? (
                      <p className="d-flex text-left">No books found</p>
                    ) : (
                      <p></p>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default BookListPage;
